module.exports = __webpack_public_path__ + "img/OBCINA JESENICE.12996fe5.png";